export const OTP_RESEND_COOLDOWN_SECONDS = 60

export const formatOtpRemainingTime = seconds => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  if (mins > 0) {
    return `${mins}m ${secs}s`
  }
  return `${secs}s`
}

export const getOtpCooldownFromResponse = (data, fallback = OTP_RESEND_COOLDOWN_SECONDS) =>
  data?.cooldownSeconds ?? fallback

export const isApiActionSuccess = result => {
  if (result === true) return true
  if (result === false) return false
  const { statusCode, status } = result?.payload || {}
  return statusCode === 200 && !!status
}

export const getOtpResendErrorMessage = (t, errorCode, data, fallbackMsg) => {
  if (
    (errorCode === "OTP_RESEND_COOLDOWN" ||
      errorCode === "RATE_LIMITED" ||
      errorCode === "OTP_SEND_LIMITED") &&
    data?.remainingSeconds
  ) {
    return t("Too many OTP resend requests. Please try again after {{time}}.", {
      time: formatOtpRemainingTime(data.remainingSeconds),
    })
  }
  return fallbackMsg
}
